import './collapsable-container-header.css';
import { ReactComponent as ChevronIcon } from '../../../assets/chevron-up.svg';

export const CollapsableContainerHeader = ({ label, count, hideCount, onClear }) => {
  const handleClearClicked = (e) => {
    onClear?.();
    e.stopPropagation();
  };
  return (
    <div className="collapsable-container-header">
      <div className="collapsable-container-label">{label}</div>
      {count > 0 && (
        <>
          <div className="collapsable-container-clear" onClick={handleClearClicked}>
            clear
          </div>
          {!hideCount && <div className="collapsable-container-count">{count}</div>}
        </>
      )}
      <div className="collapsable-container-icon">
        <ChevronIcon />
      </div>
    </div>
  );
};
